module.exports = __webpack_public_path__ + "img/SolidEdge_Step_1.4fd6f9bc.png";